import { createSlice } from '@reduxjs/toolkit';

import { AgentState, LoadMainAction, LoadUserAction, SetMainLoadedAction, SetUserLoadedAction } from './interface';
import { RootState } from 'store/rootReducer';

const initialState: AgentState = {
  isLoading: true,
  isFailed: false,
  balance: 0,
  users: [],
  isUserLoading: true,
  isUserFailed: false,
  userBalance: 0,
  operations: [],
  userOperations: [],
  withdrawals: [],
  userCanPay: false,
};

export const { actions, reducer } = createSlice({
  name: 'agent',
  initialState,
  reducers: {
    loadMain(state, _: LoadMainAction) {
      state.isLoading = true;
      state.isFailed = false;
    },
    setMainFailed(state) {
      state.isLoading = false;
      state.isFailed = true;
    },
    setMainLoaded(state, action: SetMainLoadedAction) {
      const { balance, users, operations, withdrawals } = action.payload;

      state.isLoading = false;
      state.users = users;
      state.balance = balance;
      state.operations = operations;
      state.withdrawals = withdrawals;
    },
    loadUser(state, action: LoadUserAction) {
      state.isUserLoading = true;
      state.isUserFailed = false;
    },
    setUserFailed(state) {
      state.isUserLoading = false;
      state.isUserFailed = true;
    },
    setUserLoaded(state, action: SetUserLoadedAction) {
      const { balance, operations, canPay } = action.payload;

      state.isUserLoading = false;
      state.userBalance = balance;
      state.userOperations = operations;
      state.userCanPay = canPay;
    },
  },
});

export { reducer as agentReducer, actions as agentActions };

export const agentSelector = (state: RootState) => state.agent;
